// extracted by mini-css-extract-plugin
export default {"menuIcons":"DataContext_menuIcons__9lVO8"};